import { TFaq } from 'shared/types/faq';
import * as style from './FaqItem.css';
import { useToggleState } from '@cian/react-utils';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

type TFaqItemProps = TFaq;

export const FaqItem: React.FC<TFaqItemProps> = ({ answer, question, id }) => {
  const device = useDeviceType();

  const { state: isOpen, toggle: toggleIsOpen } = useToggleState(false);

  return (
    <div className={clsx(style['container'], device !== 'desktop' && style['container-tablet'])}>
      <div className={style['question-wrapper']} onClick={toggleIsOpen}>
        <div className={style['question']}>{question}</div>
        <div className={clsx(style['arrow'], isOpen && style['openned'])} />
      </div>
      <div className={clsx(style['answer-wrapper'], isOpen && style['openned'])}>
        {answer.map((item, index) => (
          <div key={index}>
            {id === 3 && index === 1 ? (
              <div className={style['text']}>
                Шаблон договора аренды вы найдете на{' '}
                <a href="https://pik-arenda.ru/assets/uploads/agreement_insurance.pdf" target="_blank" rel="noreferrer">
                  pik-arenda.ru
                </a>
              </div>
            ) : (
              <div className={style['text']}>{item.text}</div>
            )}
            {item.list && (
              <ul className={style['list']}>
                {item.list.map((listItem, index) => (
                  <li className={style['list-item']} key={index}>
                    {listItem}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
